module.exports = __webpack_public_path__ + "img/logo-daib.f412935b.svg";